/* POZONE — Apparition douce au défilement (.pz-rv -> .pz-vis)
   Respecte prefers-reduced-motion. Réobserve à chaque chargement
   de section dans l'éditeur de thème Shopify. */
(function () {
  function reveal(root) {
    var els = (root || document).querySelectorAll('.pz-rv:not(.pz-vis)');
    if (!els.length) return;
    if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      els.forEach(function (el) { el.classList.add('pz-vis'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) {
          e.target.classList.add('pz-vis');
          io.unobserve(e.target);
        }
      });
    }, { threshold: 0.08, rootMargin: '0px 0px -36px 0px' });
    els.forEach(function (el) { io.observe(el); });
  }

  if (document.readyState !== 'loading') {
    reveal();
  } else {
    document.addEventListener('DOMContentLoaded', function () { reveal(); });
  }

  /* Éditeur de thème : réactiver l'observation quand une section est rechargée */
  document.addEventListener('shopify:section:load', function (e) {
    reveal(e.target);
  });
})();
